exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.member-options[data-v-bc1d179a] {\r\n    display: -webkit-box;\r\n    display: -ms-flexbox;\r\n    display: flex;\r\n    -webkit-box-align: center;\r\n        -ms-flex-align: center;\r\n            align-items: center;\n}\n.member-code[data-v-bc1d179a] {\r\n    font-size: 11px;\r\n    color: #666;\r\n    margin-left: 2px;\n}\n.empty[data-v-bc1d179a] {\r\n    width: 0;\n}\r\n", ""]);

// exports
